import { Calendar, globalizeLocalizer } from "react-big-calendar";
import globalize from "globalize";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { format } from "date-fns";
import { useDispatch, useSelector } from "react-redux";
import Filters from "./filters/filters";
import { Card, Tag, Row, Col , Segmented } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { loadUniquesInField } from "../interfaces/filterInterface";
import {
  clearCalendarData,
  setFilteredProducts,
  setSelectedProduct,
} from "../features/calendarSlice";
import { loadProductAgreements, loadProductAvailability } from "../interfaces/calendarInterface";
import {
  checkEqual,
  clampDatesToMonth,
  getAllDatesInMonth,
  getCurrentMonthYear,
  getRandomColor,
  isEmpty,
  monthYearStrToDate,
  toYMD,
} from "../helpers/helper";
import { isEqual } from "lodash";
import PersistantRef from "./atoms/PersistantRef";
import CalendarHoc from "./CalendarHoc";

const localizer = globalizeLocalizer(globalize);

const btnStyle = {
  margin: "0 1px",
  padding: "6px 12px",
  backgroundColor: "#1677ff",
  color: "#fff",
  border: "none",
  borderRadius: "4px",
  cursor: "pointer",
};

import { DatePicker } from "antd";
import { ArrowRightOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import LabeledBox from "./atoms/LabeledBox";


const CustomToolbar = (toolbarProps) => {
  const goToBack = () => toolbarProps.onNavigate("PREV");
  const goToNext = () => toolbarProps.onNavigate("NEXT");
  const goToToday = () => toolbarProps.onNavigate("TODAY");
  const label = format(toolbarProps.date, "MMMM yyyy");

  const jump = (value) => {
    if (!value) return;
    const year = value.year();
    const month = value.month();
    toolbarProps.onNavigate("DATE", new Date(year, month, 1));
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "10px 0",
        fontWeight: "bold",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
        <div style={{ fontSize: "1.5rem", margin: "0 10px" }}>{label}</div>

        {/* Jump Capsule */}
<div className="flex items-center gap-2 bg-gray-50 border border-gray-200 rounded-xl px-3 py-1.5 float-right">
  <span className="text-[11px] font-semibold text-indigo-500 tracking-wide uppercase whitespace-nowrap">
    Jump to
  </span>
  <div className="w-px h-4 bg-gray-200" />
  <DatePicker
    picker="month"
    allowClear={false}
    size="small"
    value={dayjs(toolbarProps.date)}
    onChange={jump}
    style={{ width: 110 }}
    className="!border-0 !bg-transparent !shadow-none !text-sm !font-medium"
  />
</div>


        </div>


      <div>
        <button onClick={goToBack} style={btnStyle}>{"<"}</button>
        <button onClick={goToToday} style={btnStyle}>{"II"}</button>
        <button onClick={goToNext} style={btnStyle}>{">"}</button>
      </div>
    </div>
  );
};



const LeftSidebar = ({
  plotAvailable,
  setPlotAvailable,
  quantityView,
  setQuantityView,
  productColors={}
}) => {
  const dispatch = useDispatch();
  const filteredProducts = useSelector((state) => state.calendar.data.products);
  const filterValues = useSelector((state) => state.calendar.filters);
  const selectedProducts = useSelector(
    (state) => state.calendar.data.selectedProducts
  );
  const previousFilterValues = new PersistantRef("previousFilterValues");

  useEffect(() => {
    if (
      Object.keys(filterValues).length !== 0 &&
      !checkEqual(filterValues, previousFilterValues.getValue())
    ) {
      dispatch(clearCalendarData());
      loadUniquesInField(
        "rental.name,type,totalUnits,id",
        filterValues,
        dispatch,
        setFilteredProducts,
        100,
        false
      );
      previousFilterValues.setValue(filterValues);
    }
  }, [filterValues]);

  const selectedCount = Object.keys(selectedProducts).length;

  return (
    <div className="p-2.5 h-screen overflow-y-auto">
      {/* Filters Section */}
      <div className="mb-3">
        <Filters dispatch={dispatch} filterPage="calendar" values={filterValues} vertical={true} />
      </div>

      {/* View Options Card */}
      <div
        className="rounded-lg p-2.5 mb-3"
        style={{
          background: 'linear-gradient(135deg, #1890ff 0%, #096dd9 100%)',
          boxShadow: '0 4px 6px -1px rgba(24, 144, 255, 0.2), 0 2px 4px -1px rgba(24, 144, 255, 0.1)'
        }}
      >
        {/* Mode Toggle */}
        <div className="mb-2">
          <div className="flex items-center gap-1 mb-1">
            <div
              className="w-0.5 h-2 rounded-sm"
              style={{ background: 'rgba(255, 255, 255, 0.6)' }}
            />
            <div className="text-[9px] font-bold uppercase tracking-wide text-white/90">
              Mode
            </div>
          </div>
          <div
            className="flex w-full rounded-md p-0.5 gap-0.5"
            style={{
              background: 'rgba(255, 255, 255, 0.15)',
              backdropFilter: 'blur(10px)',
              boxShadow: 'inset 0 2px 4px rgba(0, 0, 0, 0.1)'
            }}
          >
            <button
              onClick={() => setPlotAvailable(false)}
              className={`flex-1 py-1 px-2 rounded text-[11px] font-semibold transition-all duration-300 ${
                !plotAvailable
                  ? 'bg-white text-[#1890ff] shadow-sm'
                  : 'text-white/70 hover:text-white/95 hover:-translate-y-px'
              }`}
              style={{
                boxShadow: !plotAvailable ? '0 2px 4px -1px rgba(0, 0, 0, 0.15), 0 1px 2px -1px rgba(0, 0, 0, 0.1)' : 'none'
              }}
            >
              Agreements
            </button>
            <button
              onClick={() => setPlotAvailable(true)}
              className={`flex-1 py-1 px-2 rounded text-[11px] font-semibold transition-all duration-300 ${
                plotAvailable
                  ? 'bg-white text-[#1890ff] shadow-sm'
                  : 'text-white/70 hover:text-white/95 hover:-translate-y-px'
              }`}
              style={{
                boxShadow: plotAvailable ? '0 2px 4px -1px rgba(0, 0, 0, 0.15), 0 1px 2px -1px rgba(0, 0, 0, 0.1)' : 'none'
              }}
            >
              Availability
            </button>
          </div>
        </div>

        {/* Quantity Toggle */}
        {plotAvailable && (
          <div>
            <div className="flex items-center gap-1 mb-1">
              <div
                className="w-0.5 h-2 rounded-sm"
                style={{ background: 'rgba(255, 255, 255, 0.6)' }}
              />
              <div className="text-[9px] font-bold uppercase tracking-wide text-white/90">
                Quantity
              </div>
            </div>
            <div
              className="flex w-full rounded-md p-0.5 gap-0.5"
              style={{
                background: 'rgba(255, 255, 255, 0.15)',
                backdropFilter: 'blur(10px)',
                boxShadow: 'inset 0 2px 4px rgba(0, 0, 0, 0.1)'
              }}
            >
              <button
                onClick={() => setQuantityView("used")}
                className={`flex-1 py-1 px-2 rounded text-[11px] font-semibold transition-all duration-300 ${
                  quantityView === "used"
                    ? 'bg-white text-[#1890ff] shadow-sm'
                    : 'text-white/70 hover:text-white/95 hover:-translate-y-px'
                }`}
                style={{
                  boxShadow: quantityView === "used" ? '0 2px 4px -1px rgba(0, 0, 0, 0.15), 0 1px 2px -1px rgba(0, 0, 0, 0.1)' : 'none'
                }}
              >
                Used
              </button>
              <button
                onClick={() => setQuantityView("unused")}
                className={`flex-1 py-1 px-2 rounded text-[11px] font-semibold transition-all duration-300 ${
                  quantityView === "unused"
                    ? 'bg-white text-[#1890ff] shadow-sm'
                    : 'text-white/70 hover:text-white/95 hover:-translate-y-px'
                }`}
                style={{
                  boxShadow: quantityView === "unused" ? '0 2px 4px -1px rgba(0, 0, 0, 0.15), 0 1px 2px -1px rgba(0, 0, 0, 0.1)' : 'none'
                }}
              >
                Unused
              </button>
            </div>
          </div>
        )}
      </div>

      {/* Products Card */}
      {filteredProducts?.length > 0 && (
        <div
          className="bg-white border border-slate-200 rounded-lg overflow-hidden"
          style={{ boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)' }}
        >
          {/* Header */}
          <div
            className="px-2.5 py-2 border-b border-slate-200 flex justify-between items-center"
            style={{ background: 'linear-gradient(to bottom, #fafafa, #f5f5f5)' }}
          >
            <span className="text-[11px] font-semibold text-slate-800">Available Products</span>
            <span
              className="inline-flex items-center px-1.5 py-0.5 rounded-lg text-[9px] font-semibold text-white"
              style={{
                background: 'linear-gradient(135deg, #1890ff 0%, #096dd9 100%)',
                boxShadow: '0 2px 4px rgba(24, 144, 255, 0.3)'
              }}
            >
              {selectedCount}
            </span>
          </div>

          {/* Products List */}
          <div
            className="p-2 bg-[#fafafa]"
            style={{
              maxHeight: 'calc(100vh - 400px)',
              overflowY: 'auto'
            }}
          >
            <div className="flex flex-wrap gap-1">
              {Object.keys(selectedProducts).map((id) => (
                <div
                  key={`prod-${id}`}
                  onClick={() =>
                    dispatch(
                      setSelectedProduct({
                        id,
                        name: selectedProducts[id],
                      })
                    )
                  }
                  className="px-2 py-1 rounded-md text-[11px] font-medium text-white cursor-pointer transition-all duration-200 border hover:-translate-y-0.5 relative overflow-hidden group"
                  style={{
                    background: productColors[`available_${id}`] && plotAvailable ? productColors[`available_${id}`] : 'linear-gradient(135deg, #1890ff 0%, #096dd9 100%)',
                    borderColor: '#1890ff',
                    boxShadow: '0 2px 6px rgba(24, 144, 255, 0.35)'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.boxShadow = '0 3px 10px rgba(24, 144, 255, 0.45)';
                    e.currentTarget.style.transform = 'translateY(-2px)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.boxShadow = '0 2px 6px rgba(24, 144, 255, 0.35)';
                    e.currentTarget.style.transform = 'translateY(0)';
                  }}
                >
                  <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-500" />
                  {selectedProducts[id]}
                </div>
              ))}

              {filteredProducts.map((item) => {
                if (item.id in selectedProducts) return null;
                return (
                  <div
                  // draggable={true}
                    key={`prod-${item.id}`}
                    onClick={() =>
                      dispatch(setSelectedProduct({ id: item.id, name: item.name }))
                    }
                    className="px-2 py-1 rounded-md text-[11px] font-medium text-slate-600 cursor-pointer transition-all duration-200 border border-slate-300 bg-white hover:border-slate-400 hover:bg-slate-50 hover:-translate-y-px relative overflow-hidden group"
                    style={{
                      boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.1)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.boxShadow = '0 1px 2px rgba(0, 0, 0, 0.05)';
                    }}
                  >
                    <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/40 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-500" />
                    {item.name}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
const CalendarView = () => {
  const selectedProducts = useSelector(
    (state) => state.calendar.data.selectedProducts
  );
  const previousSelectedProducts = new PersistantRef('previousSelectedProducts');
  const [searchParams,setSearchParams] = useSearchParams();

const rentalId = searchParams.get("rentalId");
const rentalName = searchParams.get("rentalName");
const rentalType = searchParams.get("rentalType");
const rentalQuantity =searchParams.get("rentalTotalUnits");
  const agreementSchedule = useSelector(
    (state) => state.calendar.data.agreements ?? {}
  );
  const availability = useSelector(
    (state) => state.calendar.data.availability ?? {}
  );
  const idFilteredData = useSelector(
    (state) => state.calendar.data.idData ?? {}
  );

  const [plotAvailable, setPlotAvailable] = useState(true);
  const [quantityView, setQuantityView] = useState('used');
  const previousSelectedMonth = new PersistantRef('previousSelectedMonth');
  const [selectedMonth, setSelectedMonth] = useState(
    isEmpty(previousSelectedMonth.getValue())
      ? getCurrentMonthYear()
      : previousSelectedMonth.getValue()
  );
  const dispatch = useDispatch();
  const colorMap = new PersistantRef('colorMap');

  var events = [];
  if (!plotAvailable) {
    for (var pId of Object.keys(agreementSchedule[selectedMonth] ?? {})) {
      for (var eventKey of Object.keys(agreementSchedule[selectedMonth][pId])) {
        if (!(pId in selectedProducts)) continue;
        const event = agreementSchedule[selectedMonth][pId][eventKey];
        const uniqueId = event.id || `${pId}-${eventKey}`;
        if (!colorMap.getValue()[uniqueId]) {
          colorMap.getValue()[uniqueId] = getRandomColor();
        }
        const { startDate, endDate } = clampDatesToMonth(
          new Date(event.startDate),
          new Date(event.endDate),
          selectedMonth
        );
        events.push({
          color: colorMap.getValue()[uniqueId],
          start: new Date(startDate),
          end: new Date(endDate),
          title: event.rental.name + " - " + event.rentalAgreement.tenant.email,
        });
      }
    }
 } else {

   for (var pId of Object.keys(availability[selectedMonth] ?? {})) {
  if (!(pId in selectedProducts)) continue;

  if (!colorMap.getValue()[`available_${pId}`]) {
    colorMap.getValue()[`available_${pId}`] = getRandomColor();
  }

  const allDates = new Set(getAllDatesInMonth(selectedMonth));

  // BOOKED / USED DAYS
  if(!availability[selectedMonth][pId]){
    continue
  }
  for (var event of availability[selectedMonth][pId]) {
    if(!(pId in idFilteredData)){
      break
    }
    const date = toYMD(new Date(event['date']));

    if (!allDates.has(date)) continue; // ✅ skip if not in this month
    allDates.delete(date);

    const used = parseInt(event['usedUnits']);
    const total = parseInt(idFilteredData[pId]?.['units'] || 0);
    let displayUnits = quantityView === 'used' ? used : total - used;
   if (quantityView === "used") {
  displayUnits += " 🔓";
}else {
  displayUnits += ' 🗂️'
}

    events.push({
      color: colorMap.getValue()[`available_${pId}`],
      start: new Date(event['date']),
      end: new Date(event['date']),
      // bold highlight if booked
      title: (
        <span style={{ fontWeight: used > 0 ? 700 : 400 }}>
          {`${idFilteredData[pId]['name']} - ${displayUnits}`}
        </span>
      ),
      isBooked: used > 0,
    });
  }

  // FREE DAYS
  for (var date of allDates) {
    if(!(pId in idFilteredData)){
      break
    }
    const total = parseInt(idFilteredData[pId]?.['units'] || 0);
    events.push({
      color: colorMap.getValue()[`available_${pId}`],
      start: new Date(date),
      end: new Date(date),
      title: (
        <span style={{ fontWeight: 400 }}>
          {`${
            idFilteredData[pId]['name'].length > 20
              ? idFilteredData[pId]['name'].slice(0, 18) + '...'
              : idFilteredData[pId]['name']
          } - ${quantityView === 'used' ? 0 : total}`}
        </span>
      ),
      isBooked: false,
    });
  }
}


  }
  useEffect(()=>{
    if (rentalId && rentalName && rentalQuantity && rentalType){
      setQuantityView('unused')
      setPlotAvailable(true)
       dispatch(setSelectedProduct({id:rentalId,name:rentalName,fromUrl:true,type:rentalType,totalUnits:rentalQuantity}))
       setSearchParams({})
    // dispatch(setFilteredProducts([{id:rentalId,name:rentalName,type:rentalType,totalUnits:rentalQuantity}]))


    }
  },[rentalId])

  useEffect(() => {
    if (selectedProducts.length === 0) return;
    if (
      !isEqual(selectedMonth, previousSelectedMonth.getValue()) ||
      !isEqual(selectedProducts, previousSelectedProducts.getValue())
    ) {

      previousSelectedMonth.setValue(selectedMonth);
      previousSelectedProducts.setValue(selectedProducts);
    }
    if (plotAvailable) {
        loadProductAvailability(dispatch, selectedMonth, selectedProducts, {});
      } else {
        loadProductAgreements(
          dispatch,
          selectedMonth,
          selectedProducts,
          agreementSchedule
        );
      }
  }, [selectedProducts, selectedMonth , plotAvailable]);

  return (
    <div style={{ height: "100vh", padding: 0, margin: 0 }}>
      <Row style={{ height: "100%" }}>
        <Col span={4} style={{ borderRight: "1px solid #f0f0f0" }}>
          <LeftSidebar
            plotAvailable={plotAvailable}
            setPlotAvailable={setPlotAvailable}
            quantityView={quantityView}
            setQuantityView={setQuantityView}
            productColors={colorMap.getValue()}
          />
        </Col>
        <Col span={20}>
          <CalendarHoc
          isDnd={false}
            views={["month"]}
            events={events}
            localizer={localizer}
            date={monthYearStrToDate(selectedMonth)}
            onNavigate={
              (date, _) => {
              const month = date.toLocaleString("default", { month: "long" });
              const year = date.getFullYear();
              setSelectedMonth(`${month} ${year}`);
              }
            }
            style={{ height: "100vh", padding: 0, margin: 0 }}
            components={{ toolbar: CustomToolbar }}
            startAccessor="start"
            endAccessor="end"
            popup={true}
           eventPropGetter={(event) => ({
  style: {
    backgroundColor: event.color + '18',        // ~10% opacity tint of the event color
    color: event.color,                          // text matches the color
    borderLeft: `3px solid ${event.color}`,      // colored left bar accent
    borderTop: 'none',
    borderRight: 'none',
    borderBottom: 'none',
    borderRadius: '5px',
    fontSize: '11px',
    fontWeight: '600',
    fontFamily: 'Inter, sans-serif',
    padding: '2px 6px',
    boxShadow: 'none',
  },
})}
          />
        </Col>
      </Row>
    </div>
  );
};

export default CalendarView;
